import React, { useEffect, useState } from "react"
import { Box, Button, Checkbox, Divider, Grid, makeStyles } from "@material-ui/core"
import { MailOutline } from "@material-ui/icons"
import { ActionCard, LoadingSpinner, useSnackbar } from "../../components"
import { useMutationUpdateSelf, useQueryAdminableUser } from "../../data"
import { useAuth } from "../../services"

const useStyles = makeStyles((theme) => ({
  info: {
    fontSize: 14,
    color: theme.palette.text.light,
    display: "flex",
    flexGrow: 1,
  },
  chip: {
    marginRight: theme.spacing(1),
  },
  stub: {
    marginLeft: -10,
  },
  completed: {
    color: theme.palette.success.main,
  },
}))

const SimpleNotifications = () => {
  const classes = useStyles()
  const { principal } = useAuth()
  const { data } = useQueryAdminableUser({ variables: { id: principal.userID, organisation: principal.organisation } })
  const [updateSelf] = useMutationUpdateSelf()
  const snackbar = useSnackbar()

  const [loading, setLoading] = useState(true)
  const [touched, setTouched] = useState(false)
  const [midday, setMidday] = useState(false)
  const [evening, setEvening] = useState(false)
  const [overdue, setOverdue] = useState(false)

  useEffect(() => {
    if (data) {
      setLoading(false)
      const { adminableUser: user } = data
      setMidday(user.settings.notifications.simple.midday)
      setEvening(user.settings.notifications.simple.evening)
      setOverdue(user.settings.notifications.simple.overdue)
    }
  }, [data])

  const handleSave = async () => {
    try {
      setLoading(true)
      const variables = { simpleNotifications: { midday, evening, overdue } }
      await updateSelf({ variables })
      setLoading(false)
      setTouched(false)
      snackbar.showMessage({ message: "Email notifications updated", icon: <MailOutline /> })
    } catch (error) {
      snackbar.showMessage({ message: error.message })
    }
  }

  const NotificationActionCard = ({ title, description, value, setter }) => {
    const handleChange = () => {
      setTouched(true)
      setter(!value)
    }

    return (
      <ActionCard
        title={title}
        detail={description}
        stub={
          <Grid item className={classes.stub}>
            <Checkbox color="primary" checked={value} onClick={handleChange} />
          </Grid>
        }
        rightChildren={<MailOutline />}
      />
    )
  }

  return (
    <>
      <Box mb={5}>
        {!data && (
          <Box display="flex" justifyContent="center">
            <LoadingSpinner size={60} />
          </Box>
        )}
        {data && (
          <>
            <NotificationActionCard
              title="Midday status update"
              description="One email sent per business location around midday, showing current status for the locations active jobs"
              setter={setMidday}
              value={midday}
            />
            <NotificationActionCard
              title="Evening status update"
              description="One email sent per business location around 6PM, showing current status for the locations active jobs"
              setter={setEvening}
              value={evening}
            />
            <NotificationActionCard
              title="Job overdue notification"
              description="One email sent when an uncompleted job, with a set due time, becomes overdue"
              setter={setOverdue}
              value={overdue}
            />
          </>
        )}
      </Box>

      <Divider />

      <Box display="flex" flexDirection="row" justifyContent="flex-end" alignItems="center" mt={2}>
        <Button variant="contained" color="primary" onClick={handleSave} disabled={!touched || loading}>
          <Box px={2}>Save</Box>
        </Button>
      </Box>
    </>
  )
}

export default SimpleNotifications
